import * as React from 'react';
import Box from '@mui/material/Box';
import FilledInput from '@mui/material/FilledInput';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/FilledInput": FilledInput, "@mui/material/FormControl": FormControl, "@mui/material/FormHelperText": FormHelperText, "@mui/material/Input": Input, "@mui/material/InputLabel": InputLabel, "@mui/material/OutlinedInput": OutlinedInput } } });
export default ClientProvider;
